/* eslint-disable jsx-a11y/label-has-associated-control */
import { Select } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import { setExperience } from '../../../../../../redux/reducers/talentSlice'
import { experienceOptions } from '../../../../../../utils/utils'
import * as s from './Experience.styles'

const { Option } = Select

const propTypes = {}
const defaultProps = {}

function Experience() {
  const dispatch = useDispatch()
  const { t } = useTranslation(['common', 'talentArea'], {
    useSuspense: false,
  })
  const { experience } = useSelector((state) => state.talent)

  const handleOnChange = (value) => {
    dispatch(setExperience(value))
  }
  return (
    <s.ExperienceWrapper>
      <label className="field-label">{t('common:experienceForm.label')}</label>
      <Select
        onChange={handleOnChange}
        placeholder="Select experience"
        defaultValue={experience}
      >
        {Object.entries(experienceOptions(t)).map((el) => (
          <Option key={el[0]} value={el[0]}>
            {el[1]}
          </Option>
        ))}
      </Select>
    </s.ExperienceWrapper>
  )
}

Experience.propTypes = propTypes
Experience.defaultProps = defaultProps

export default Experience
